import { Button, Grid } from "@mui/material";
import { buttonStyles } from "./styles/buttonStyle";
type GridSizes = {
  lg?: boolean | number | "auto";
  md?: boolean | number | "auto";
  sm?: boolean | number | "auto";
  xs?: boolean | number | "auto";
};
type Props = {
  label: string;
  onClick: Function;
  sizes?: GridSizes;
};

export const FooterButton = ({
  label,
  onClick,
  sizes = { lg: 2, md: 2, sm: 6, xs: 6 },
}: Props) => {
  return (
    <Grid container justifyContent="flex-end">
      <Grid
        item
        lg={sizes.lg}
        md={sizes.md}
        sm={sizes.sm}
        xs={sizes.xs}
        sx={buttonStyles.btnModal}
      >
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => onClick()}
        >
          NEW {label}
        </Button>
      </Grid>
    </Grid>
  );
};
